
.checkbox {
    width: 1rem;
    height: 1rem;
    accent-color: var(--primary-enabled, #ff5823);
    border-radius: 6px;
}

.checkbox:hover {
    cursor: pointer;
}

.checkbox:disabled {
    opacity: 0.5;
}